import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import { MessageVM } from '../../../models';
import { UserType } from '../../../models/UserType';

@Component({
  selector: 'account-message-view',
  templateUrl: 'messageview.component.html'
})
export class MessageViewComponent extends BaseComponent implements OnInit {

  model: MessageVM[] = [];
  canReply: boolean = false;

  constructor(private route: ActivatedRoute, private accService: AccountService, private router: Router) {
    super(route);
  }

  ngOnInit(): void {
    this.emitDisplayLoadingDialog(true);
    const msgid = this.route.params
      .subscribe(params => {
        let id = params['id'];
        this.loadMessage(id);
      });
  }

  loadMessage(id: string) {
    this.accService.getMessage(id)
      .subscribe(returnValue => {
        this.model = returnValue;
        this.emitDisplayLoadingDialog(false);

        if (returnValue.length == 0) {
          this.router.navigateByUrl('/messages');
        }

        this.checkCanReply();
      });
  }

  checkCanReply() {
    var otherPartyId = (this.model[0].from.userType != UserType.client) ? this.model[0].from.userId : this.model[0].to.userId
    this.accService.canReply(otherPartyId).subscribe(
      r => {
        this.canReply = r;
      }
    );
  }

  reply() {
    var otherParty = (this.model[0].from.userType != UserType.client) ? this.model[0].from : this.model[0].to;
    this.accService.messageOtherParty = otherParty;

    this.router.navigateByUrl('/messagewrite');
  }

  otherPartyName() {
    var name = (this.model[0].from.userType != UserType.client) ? this.model[0].from.name : this.model[0].to.name;

    return name;
  }

}
